import React from 'react';
import EvaForm from '../../components/Eva/EvaForm.Component';
import { useParams } from 'react-router';

function EvaluationCreate(){
    const { id } = useParams();
    return (
        <div>
            <EvaForm mode='create' id={id}/>
        </div>
    )
}

export default EvaluationCreate;